import axios from 'axios'
import Auth from '@aws-amplify/auth'

import { getToken } from './utils/auth' // getToken from cookie

axios.interceptors.request.use(async (config) => {
  const auth = await Auth.currentSession();
  const authToken = auth.idToken.jwtToken;
  //console.log(auth.idToken.jwtToken)
  //const access_token = getToken()
  if (authToken != null) {
    config.headers.Authorization = `Bearer ${authToken}`
  }
  //console.log('Starting Request', config)
  return config
}, function (err) {
  return Promise.reject(err)
})

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  return Promise.reject(error)
})
